// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__WnOj4","products":"Search_products__vrSGU","header":"Search_header__IM6BZ","goBack":"Search_goBack__SHYZf","title":"Search_title__DjCXN"};